import { React, useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import ApiConfig from '../api/ApiConfig';
import { simpleGetCall, simplePostCall } from '../api/ApiServices';
import swal from 'sweetalert';

const AboutUs = () => {
  const { sidebar } = useContext(AppContext);
  const [first, setfirst] = useState(false)
  const [aboutUsTxt, setAboutUsTxt] = useState({});

  useEffect(() => {
    fetchAboutUS();
  }, []);

  const fetchAboutUS = () => {
    simpleGetCall(ApiConfig.GET_ABOUT_US)
      .then((data) => {
        setAboutUsTxt(data.commonText);
        // setLoading(false);
        console.log("Privacy Data", data.commonText);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const updateAbout = (e) => {
    e.preventDefault();
    let reqBody = JSON.stringify({
      commanTextReq: aboutUsTxt
    })

    simplePostCall(ApiConfig.UPDATE_ABOUT_US, reqBody)
      .then((res) => {
        console.log("FInal Data", res);
        swal({
          text: res.message,
          icon: "success",
          timer: 2000,
          dangerMode: false,
          button: false
        });
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  }


  return (
    <main
      id="cx-main"
      className={sidebar ? "about-main" : " about-main cx-active"}
    >
      <div className="innerContent">
        <div className="heading-common mb-3">
          <label>ABOUT US</label>
        </div>
        <div className="cx-card-round">
          <div className="form-group">
            <label>About Us Content</label>
            <textarea
              className="form-control"
              placeholder="Please write something about us"
              id="floatingTextarea2"
              style={{ height: "250px" }}
              value={aboutUsTxt}
              onChange={(e) => { setAboutUsTxt(e.target.value) }}
            ></textarea>
            <div className="text-end">
              <button className="aboutUsSaveBtn" onClick={updateAbout}>Save</button>
            </div>
            {/* <div className="btn-slide">
              <button className={ first ? "btn btn-1 btn1-active" : "btn btn-1"}>Absent</button>
              <label htmlFor="" className="mx-2" onClick={()=>setfirst(!first)}>
                click
              </label>
              <button className={ first ? " btn btn-2  ": "btn btn-2 btn2-active"}>Present</button>
            </div> */}
          </div>
        </div>
      </div>
    </main>
  );
};

export default AboutUs;
